import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {
    // 判斷 API 前半部
    API(){
      return process.env.NODE_ENV === "production" ? "https://www.top-link.com.tw/" : "http://localhost/"
    }, 
    // 登入頁
    // submit_login(context){
    //   const login_api = `${process.env.NODE_ENV} `
    // }
  },
  getters: {
    api(){
      
    }
  }
})
